<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.ceramicFilterParaEdit')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/"><i class="fa fa-home"></i></router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/prd/ceramicFilterParaRecord"><span>{{$t('tlt.ceramicFilterParaRecord')}}</span></router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/prd/ceramicFilterParaEdit"><span>{{$t('tlt.ceramicFilterParaEdit')}}</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('ceramicFilterPara')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('ceramicFilterPara')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                    <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.datetime')}}：</label>
                                    <mmf-datetimepicker v-model="recTime" v-validate="'required'" name="recTime"></mmf-datetimepicker>
                                    <span v-show="errors.has('recTime')" class="lbl-obg">
                                    {{errors.first('recTime')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>location id:</label>
                                <dimSearch  validate="required" name="locId"
                                            v-model="locId" :entity="locations" submitProp="id" bindProp="id" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.location.area')}}:</label>
                                <dimSearch  validate="required" name="locName"
                                            v-model="locName" :entity="locations" submitProp="locName" bindProp="locName" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.current')}}:</label>
                                <input v-validate="'required'" name="current"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('current') }"
                                    v-model="current" type="text">
                                <span v-show="errors.has('current')" class="lbl-obg">
                                    {{errors.first('current')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.grindingVol')}}:</label>
                                <input v-validate="'required'" name="grindingVol"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('grindingVol') }"
                                    v-model="grindingVol" type="text">
                                <span v-show="errors.has('grindingVol')" class="lbl-obg">
                                    {{errors.first('grindingVol')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.waterSupply')}}:</label>
                                <input v-validate="'required'" name="waterSupply"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('waterSupply') }"
                                    v-model="waterSupply" type="text">
                                <span v-show="errors.has('waterSupply')" class="lbl-obg">
                                    {{errors.first('waterSupply')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.concentration')}}:</label>
                                <input v-validate="'required'" name="concentration"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('concentration') }"
                                    v-model="concentration" type="text">
                                <span v-show="errors.has('concentration')" class="lbl-obg">
                                    {{errors.first('concentration')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.granularity')}}:</label>
                                <input v-validate="'required'" name="granularity"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('granularity') }"
                                    v-model="granularity" type="text">
                                <span v-show="errors.has('granularity')" class="lbl-obg">
                                    {{errors.first('granularity')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.steelBall')}}:</label>
                                <input v-validate="'required'" name="steelBall"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('steelBall') }"
                                    v-model="steelBall" type="text">
                                <span v-show="errors.has('steelBall')" class="lbl-obg">
                                    {{errors.first('steelBall')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.filterCakeWater1')}}:</label>
                                <input v-validate="'required'" name="filterCakeWater1"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('filterCakeWater1') }"
                                    v-model="filterCakeWater1" type="text">
                                <span v-show="errors.has('filterCakeWater1')" class="lbl-obg">
                                    {{errors.first('filterCakeWater1')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.filterCakeWater2')}}:</label>
                                <input v-validate="'required'" name="filterCakeWater2"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('filterCakeWater2') }"
                                    v-model="filterCakeWater2" type="text">
                                <span v-show="errors.has('filterCakeWater2')" class="lbl-obg">
                                    {{errors.first('filterCakeWater2')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.filterCakeWater3')}}:</label>
                                <input v-validate="'required'" name="filterCakeWater3"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('filterCakeWater3') }"
                                    v-model="filterCakeWater3" type="text">
                                <span v-show="errors.has('filterCakeWater3')" class="lbl-obg">
                                    {{errors.first('filterCakeWater3')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.filterCakeWater4')}}:</label>
                                <input v-validate="'required'" name="filterCakeWater4"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('filterCakeWater4') }"
                                    v-model="filterCakeWater4" type="text">
                                <span v-show="errors.has('filterCakeWater4')" class="lbl-obg">
                                    {{errors.first('filterCakeWater4')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.filterCakeWater301')}}:</label>
                                <input v-validate="'required'" name="filterCakeWater301"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('filterCakeWater301') }"
                                    v-model="filterCakeWater301" type="text">
                                <span v-show="errors.has('filterCakeWater301')" class="lbl-obg">
                                    {{errors.first('filterCakeWater301')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.slurryFixedCarbon')}}:</label>
                                <input v-validate="'required'" name="slurryFixedCarbon"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('slurryFixedCarbon') }"
                                    v-model="slurryFixedCarbon" type="text">
                                <span v-show="errors.has('slurryFixedCarbon')" class="lbl-obg">
                                    {{errors.first('slurryFixedCarbon')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.pulpCaContent')}}:</label>
                                <input v-validate="'required'" name="pulpCaContent"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('pulpCaContent') }"
                                    v-model="pulpCaContent" type="text">
                                <span v-show="errors.has('pulpCaContent')" class="lbl-obg">
                                    {{errors.first('pulpCaContent')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.stronglyMixedWater')}}:</label>
                                <input v-validate="'required'" name="stronglyMixedWater"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('stronglyMixedWater') }"
                                    v-model="stronglyMixedWater" type="text">
                                <span v-show="errors.has('stronglyMixedWater')" class="lbl-obg">
                                    {{errors.first('stronglyMixedWater')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.rawBallCarbon')}}:</label>
                                <input v-validate="'required'" name="rawBallCarbon"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('rawBallCarbon') }"
                                    v-model="rawBallCarbon" type="text">
                                <span v-show="errors.has('rawBallCarbon')" class="lbl-obg">
                                    {{errors.first('rawBallCarbon')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.rawBallDropStrength')}}:</label>
                                <input v-validate="'required'" name="rawBallDropStrength"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('rawBallDropStrength') }"
                                    v-model="rawBallDropStrength" type="text">
                                <span v-show="errors.has('rawBallDropStrength')" class="lbl-obg">
                                    {{errors.first('rawBallDropStrength')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.ripeBallStrength')}}:</label>
                                <input v-validate="'required'" name="ripeBallStrength"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('ripeBallStrength') }"
                                    v-model="ripeBallStrength" type="text">
                                <span v-show="errors.has('ripeBallStrength')" class="lbl-obg">
                                    {{errors.first('ripeBallStrength')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.conversionIndex')}}:</label>
                                <input v-validate="'required'" name="conversionIndex"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('conversionIndex') }"
                                    v-model="conversionIndex" type="text">
                                <span v-show="errors.has('conversionIndex')" class="lbl-obg">
                                    {{errors.first('conversionIndex')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.abrasionIndex')}}:</label>
                                <input v-validate="'required'" name="abrasionIndex"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('abrasionIndex') }"
                                    v-model="abrasionIndex" type="text">
                                <span v-show="errors.has('abrasionIndex')" class="lbl-obg">
                                    {{errors.first('abrasionIndex')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.so2')}}:</label>
                                <input v-validate="'required'" name="so2"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('so2') }"
                                    v-model="so2" type="text">
                                <span v-show="errors.has('so2')" class="lbl-obg">
                                    {{errors.first('so2')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.nox')}}:</label>
                                <input v-validate="'required'" name="nox"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('nox') }"
                                    v-model="nox" type="text">
                                <span v-show="errors.has('nox')" class="lbl-obg">
                                    {{errors.first('nox')}}
                                </span>    
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.cfp.pm')}}:</label>
                                <input v-validate="'required'" name="pm"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('pm') }"
                                    v-model="pm" type="text">
                                <span v-show="errors.has('pm')" class="lbl-obg">
                                    {{errors.first('pm')}}
                                </span>    
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions,
        mapState
    } from "vuex";
    import {
        fields
    } from "@/model/prd/productionExecution/pelletizing/CeramicFilterPara";
    import dimSearch from "@/components/MMFDimSearch";
    import MmfDatetimepicker from '@/components/MmfDatetimepicker';

    const {
        mapFields
    } = createHelpers({
        getterType: 'ceramicFilterPara/getField',
        mutationType: 'ceramicFilterPara/updateField',
    });
export default {
    data(){
        return {};
    },
    beforeMount() {
            this.$store.dispatch('ceramicFilterPara/loadLocations');
    },
    computed: {
        ...mapFields(fields),
        ...mapState({
            locations: state => state.ceramicFilterPara.locations,
        }),          
    },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave"]),            
        },
        components: {
            dimSearch,
            MmfDatetimepicker
        }
};
</script>